<template>
  <div class="h-full">
    <div>
      <div class="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-72 lg:flex-col select-none">
        <div class="flex grow flex-col overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
          <button @click="counter++" :disabled="counter === 10" class="flex h-16 shrink-0 items-center justify-center text-center font-bold text-xl font-mono">
            VEHA Ontzorgt B.V.
          </button>
          <nav class="flex flex-1 flex-col">
            <ul role="list" class="flex flex-1 flex-col gap-y-4">
              <Navigation :routes="routes"/>
              <Navigation title="Formulieren" :routes="formRoutes" is-grouped/>
              <Navigation title="Geheime paginas" :routes="hiddenRoutes" is-grouped v-if="counter === 10"/>
              <Navigation :routes="bottomRoutes" is-bottom/>
            </ul>
          </nav>
        </div>
      </div>

      <div class="lg:pl-72">
        <TopBar/>

        <main class="py-5">
          <div class="px-5">
            <RouterView/>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import type { Route } from '@/interfaces'
import { Navigation } from '@component/Nav'
import { useNotInvoiced } from '@/composables'
import { TopBar } from '@component/Miscellaneous'
import { HomeIcon, IdentificationIcon, CircleStackIcon, UserGroupIcon, BriefcaseIcon, BuildingOfficeIcon, UserPlusIcon, WrenchIcon, LifebuoyIcon, CubeIcon, WrenchScrewdriverIcon, RectangleStackIcon } from '@heroicons/vue/24/outline'

const counter = ref<number>(0);

const routes = ref<Route[]>([
  { name: "Dashboard", route: "Admin.Dashboard", icon: HomeIcon, prefix: "Admin.Dashboard" },
  { name: "Referentie codes", route: "Admin.Forms.Reference.Dashboard", icon: IdentificationIcon, prefix: "Admin.Forms.Reference." },
  {
    name: "Data beheer",
    route: "",
    icon: CircleStackIcon,
    prefix: "Admin.Data.",
    children: [
      { name: "Medewerkers", route: "Admin.Data.Employees.Dashboard", icon: UserGroupIcon, prefix: "Admin.Data.Employees." },
      { name: "Bedrijven", route: "Admin.Data.Companies.Dashboard", icon: BriefcaseIcon, prefix: "Admin.Data.Companies." },
      { name: "Objecten", route: "Admin.Data.Objects.Dashboard", icon: BuildingOfficeIcon, prefix: "Admin.Data.Objects." },
      { name: "Contactpersonen", route: "Admin.Data.ContactPersons.Dashboard", icon: UserPlusIcon, prefix: "Admin.Data.ContactPersons." },
      { name: "Diensten", route: "Admin.Data.Services.Dashboard", icon: WrenchIcon, prefix: "Admin.Data.Services." },
      { name: "Calamiteiten", route: "Admin.Data.Disasters.Dashboard", icon: LifebuoyIcon, prefix: "Admin.Data.Disasters." },
      { name: "Materialen", route: "Admin.Data.Materials.Dashboard", icon: CubeIcon, prefix: "Admin.Data.Materials." },
      { name: "Middelen", route: "Admin.Data.Resources.Dashboard", icon: WrenchScrewdriverIcon, prefix: "Admin.Data.Resources." },
    ]
  }
]);

const { formRoutes } = useNotInvoiced([
  { name: "Project prijs", route: "Admin.Forms.ProjectPrice.Dashboard", icon: "PP", prefix: "Admin.Forms.ProjectPrice.", open: 0 },
  { name: "Regie prijs", route: "Admin.Forms.HourlyPrice.Dashboard", icon: "RP", prefix: "Admin.Forms.HourlyPrice.", open: 10 },
  { name: "Glasbewassing CSU", route: "Admin.Forms.Glasbewassing.Dashboard", icon: "CSU", prefix: "Admin.Forms.Glasbewassing.", open: 0 },
  { name: "Calamiteiten reiniging", route: "Admin.Forms.Calamiteiten.Dashboard", icon: "CR", prefix: "Admin.Forms.Calamiteiten.", open: 0 }
]);

const hiddenRoutes = ref<Route[]>([
  { name: "Taken registratie", route: "Admin.Secret.Forms.TaskRegister.Dashboard", icon: RectangleStackIcon, prefix: "Admin.Secret.Forms.TaskRegister." }
]);

const bottomRoutes = ref<Route[]>([
  { name: "Taken registratie", route: "Forms.TaskRegister", icon: RectangleStackIcon, prefix: "UnkownRoutes.", external: true },
]);

onMounted(() => {
  const body = document.getElementById("body");

  body?.classList.remove("bg-zinc-900");
  body?.classList.add("h-full");
});
</script>